import { Injectable } from '@angular/core';

@Injectable()
export class PaymentsService {

  constructor() { }

  // addCard(tokenInfo) {
  //   let fn = firebase.functions().httpsCallable('addCard');
  //   return fn(tokenInfo);
  // }

}
